import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { RouterOutlet, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RoutesMapper } from '../../../routes-mapper';
import { navType, AppConfigService } from '../../../services/config/app-config.service';
import { ThemeToggleService } from '../../../services/theme-Toggle/theme-toggle.service';
import { SsoAuthService } from '../../../sso/Services/sso-auth.service';
import { ThemeToggleComponent } from '../../theme-toggle/theme-toggle.component';
import { UserProfileHeaderComponent } from '../../user-profile-header/user-profile-header.component';
import { PhilMetaService } from '../../../services/apis/phil apis/phil-meta.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-user-phil-side-nav',
  imports: [RouterOutlet, CommonModule, ThemeToggleComponent, UserProfileHeaderComponent],
  templateUrl: './user-phil-side-nav.component.html',
  styleUrl: './user-phil-side-nav.component.scss',
})
export class UserPhilSideNavComponent {
  philName: string = environment.PHIL_NAME;
  selectedNavIndex: Number = 0;
  adminClicked: boolean = false;
  public themeStyles: any;
  userDetails: any = {};
  showThemes: boolean = false;
  public navBar: navType[] = [];
  showApps: boolean = false;
  orgUrl = environment.orgUrl;
  // accoUrl = environment.accoUrl;
  currentEntry: string = 'User'; // current view
  allPermission: any[] = [];
  isAnyPermissionPresent: boolean = false;
  isUserRitwik: boolean = false;
  constructor(
    private themeToggleService: ThemeToggleService,
    public _router: Router,
    private ssoAuthService: SsoAuthService,
    private _philMetaService: PhilMetaService,
    private _toastr: ToastrService,
    private _appConfigService: AppConfigService
  ) {
    this.themeToggleService.applyTheme('dark-gold');
  }
  ngOnInit() {
    this.fetchPermission();
    this.getAllStatus();
    let HtmlRootClass = document.getElementsByClassName('dark-gold');
    this.themeStyles = getComputedStyle(HtmlRootClass.item(0)!);
    this.userDetails = JSON.parse(localStorage.getItem('UserDetails')!);
    if (this.userDetails.isWorker && ['SPR', 'PR', 'R'].includes(this.userDetails.workerType)) {
      this.isUserRitwik = true;
    }
    this.makeUserNavBar();
    // this.navBar = this.appConfig.getSideNavigation(this.themeStyles);
    if (this._router.url.includes(RoutesMapper.ADMIN) && this.userDetails?.showAllTransactions) {
      this.getPaymentMode();
      this.philName = `${environment.PHIL_NAME} (Admin)`;
      this.makeAdminNavBar();
      this.currentEntry = 'Admin';
    } else {
      this.makeUserNavBar();
      this.currentEntry = 'User';
    }
    localStorage.setItem('current-user-rype', this.currentEntry);
    if (this.userDetails?.showAllTransactions) {
    }
    console.log('rerendering ..............', this.navBar);
    // select the side nav based on url
    let routerArray = this._router.url.split('?')[0].split('/');
    routerArray = routerArray.splice(1, routerArray.length);
    let i = 0;
    for (let navTab of this.navBar) {
      if (navTab.webRoute === routerArray[0]) {
        this.selectedNavIndex = i;
        break;
      }
      i++;
    }
    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const urlParts = event.urlAfterRedirects.split('/');
        const selected = urlParts[1] || '';
        if (selected) {
          let selectedIndex = -1;
          let selectedItem: any;
          for (let i = 0; i < this.navBar.length; i++) {
            if (this.navBar[i].webRoute === selected) {
              selectedIndex = i;
              selectedItem = this.navBar[i];
              break;
            }
          }
          if (selectedIndex != -1) {
            this.selectNavItem(selectedItem, selectedIndex);
          }
        }
      });
    const urlLastSegment: string = this._router.url.split('/').filter(Boolean).pop()!;
    this.selectedNavIndex = this.navBar.findIndex((item) => item.webRoute === urlLastSegment);
  }
  fetchPermission() {
    this.allPermission = this._appConfigService.getAllPermissions();
    this.isAnyPermissionPresent = Object.keys(this.allPermission).length > 0 ? true : false;
  }
  getPaymentMode() {
    this._philMetaService.getPaymentModes().subscribe({
      next: (result: any) => {
        //console.log(result);
        if (!result.error) {
          const options = result.data.map((item: any) => ({
            ...item,
            title: item.name,
          }));
          localStorage.setItem('payment', JSON.stringify(options));
        }
      },
      error: (error: any) => {
        this._toastr.clear();
        this._toastr.error(error);
      },
    });
  }
  getAllStatus() {
    this._philMetaService.getAllStatusses().subscribe({
      next: (response: any) => {
        if (!response.error) {
          //console.log(response.data);

          const transformedObject: any = {};
          for (const key in response.data) {
            const statusMap = response.data[key];
            if (statusMap && typeof statusMap === 'object') {
              transformedObject[key] = Object.entries(statusMap).map(([id, title]) => ({
                id: Number(id),
                title,
              }));
            } else {
              transformedObject[key] = [];
            }
          }
          console.log(transformedObject, 'test');
          localStorage.setItem('status', JSON.stringify(transformedObject));
        }
      },
    });
  }
  @HostListener('document:click')
  closeMenu() {
    this.showThemes = false;
  }
  logOut() {
    this._router.navigate(['/login']);
  }
  makeUserNavBar() {
    this.navBar = [];
    this.adminClicked = false;
    this.navBar = [
      {
        label: 'Oblation devotion',
        webRoute: RoutesMapper.NEW_DEPOSIT,
      },
      {
        label: 'All Offerings',
        webRoute: RoutesMapper.TRANSACTION,
      },
      {
        label: 'My family',
        webRoute: RoutesMapper.MY_FAMILY,
      },
      {
        label: 'Offering codes',
        webRoute: RoutesMapper.DEPOSIT_CODES,
      },
      {
        label: 'Contact Us',
        webRoute: RoutesMapper.CONTACT_US,
      },
    ];
    // if (this.isUserRitwik) {
    //   this.navBar.push({
    //     label: 'Ritwicki Account',
    //     webRoute: RoutesMapper.RITWICKI,
    //   });
    // }
  }
  makeAdminNavBar() {
    this.navBar = [];
    this.adminClicked = true;
    console.log('MAKE ADMIN NAV BAR PERMISSION: ', this.allPermission);
    this.navBar = Object.values(this.allPermission)
      .filter((item: any) => {
        const permissionObject = item?.default?.permission?.[environment.PHIL_NAME] || {};
        const adminPermissions = Object.values(permissionObject).flat();
        return adminPermissions.includes('default-rw');
      })
      .sort((a: any, b: any) => a.viewId - b.viewId)
      .map((item: any) => ({
        label: item.viewLabel,
        webRoute: item.webRoute,
        icon: item.icon,
        iconActive: item.iconActive,
        viewId: item.viewId,
      }));
  }
  onAdminClick(userType: 'User' | 'Admin') {
    if (userType === 'User') {
      this.adminClicked = false;
      this.makeUserNavBar();
      this._router.navigate([`/${RoutesMapper.NEW_DEPOSIT}`]);
    }

    if (userType === 'Admin') {
      this.adminClicked = true;
      this.makeAdminNavBar();
      const firstAdminRoute = this.navBar?.[0]?.webRoute;
      const adminRoute = firstAdminRoute
        ? `/${RoutesMapper.ADMIN}/${firstAdminRoute}`
        : `/${RoutesMapper.NEW_DEPOSIT}`;
      console.log('NAV BAR: ', this.navBar);
      this._router.navigate([adminRoute]);
    }
  }
  setTheme(theme: string, event: Event) {
    this.themeToggleService.applyTheme(theme);
  }
  onThemeClick(event: Event) {
    this.showThemes = !this.showThemes;
    if (this.showThemes) this.showApps = false;
    event.stopPropagation();
  }
  logout(event: Event) {
    this.ssoAuthService.logOut();
    event.stopPropagation();
  }
  selectNavItem(item: any, index: number) {
    //console.log(item, index)
    if (index !== this.selectedNavIndex) {
      this.selectedNavIndex = index;
      if (item.webRoute) {
        if (this._router.url.includes('/admin')) {
          this._router.navigate([`${RoutesMapper.ADMIN}/${item.webRoute}`]);
        } else {
          this._router.navigate([item.webRoute]);
        }
      }
    }
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.acco-header')) {
      this.showThemes = false;
      this.showApps = false;
    }
  }
  // toggleShowApps(e: any) {
  //   e.stopPropagation()
  //   this.showThemes = false;
  //   this.showApps = !this.showApps;
  // }
  // clickApps(url: string) {
  //   window.location.href = url;
  // }
  // onViewProfile(): void {
  //   window.open(environment.SSO_URL + '/dashboard', '_blank');
  // }
  // logOut() {
  //   localStorage.clear();
  //   this._router.navigate(['/login']);
  // }
  // onSelectTheme(value: number) {
  //   value === 1
  //     ? this.themeToggleService.applyTheme('dark-gold')
  //     : this.themeToggleService.applyTheme('light-gold');
  // }
}
